import React from "react";

const TransactionSkeleton = (cradNumber) => {
  const loadings = new Array(cradNumber).fill();
  return (
    <>
      {loadings.map((_, i) => (
        <li key={i} className={`transaction loadingStyle`}></li>
      ))}
    </>
  );
};

export default TransactionSkeleton;
